module.exports = "/* dummy val to identify this style sheet in style section  */\n.se-element {\n  display: block;\n}\n.videotag {\n  width: 100%;\n  height: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-video-youtube/se-video-youtube.component.css
// module id = ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-video-youtube/se-video-youtube.component.css
// module chunks = main